const COLORS = {
  K: "#3B2350", W: "#FFFFFF", P: "#FF7EB6", D: "#E0478A", Y: "#FFD66B", O: "#F5A623",
  L: "#C9B6FF", V: "#8E6BD8", G: "#7BD88F", B: "#A9D8FF", C: "#FF9FCB", S: "#E4DEF0",
  R: "#FF6F9C", N: "#C98B5E",
};

const GRIDS = {
  pixel_heart: [
    "..KKK..KKK..", ".KPPPKKPPPK.", "KPWPPPPPPPPK", "KPWPPPPPPPPK", "KPPPKPPKPPPK",
    "KPPCPPPPCPPK", ".KPPPKKPPPK.", "..KPPPPPPK..", "...KPPPPK...", "....KPPK....", ".....KK.....",
  ],
  pixel_coin: [
    "...KKKKKK...", "..KYYYYYYK..", ".KYYWYYYYOK.", "KYYWYYYYYYOK", "KYYYKYYKYYOK", "KYYYKYYKYYOK",
    "KYCYYYYYYCOK", "KYYYYKKYYYOK", "KYYYYYYYYYOK", ".KYYYYYYYOK.", "..KOOOOOOK..", "...KKKKKK...",
  ],
  pixel_star: [
    "......K......", ".....KYK.....", ".....KYK.....", "....KYYYK....", "KKKKYWYYYKKKK", "KYYYWYYYYYYYK",
    ".KYYYKYKYYYK.", "..KYCYYYCYK..", "..KYYYYYYYK..", ".KYYYKKKYYYK.", ".KYYK...KYYK.", "KYKK.....KKYK", "KKK.......KKK",
  ],
  pixel_mushroom: [
    "...KKKKKK...", "..KRRWWRRK..", ".KRRWWWRRRK.", "KRWRRRRRWWRK", "KWWRRRRRWWRK", "KRRRRWWRRRRK",
    "KKKKKKKKKKKK", "..KWWWWWWK..", "..KWKWWKWK..", "..KCWWWWCK..", "..KWWWWWWK..", "...KKKKKK...",
  ],
  pixel_trophy: [
    "KKKKKKKKKKKK", "KYKYYWYYYKYK", "KYKYWYYYYKYK", ".KKYKYYKYKK.", "..KYYYYYYK..", "..KYCYYCYK..",
    "...KYYYYK...", "....KYYK....", ".....KK.....", "....KOOK....", "...KOOOOK...", "...KKKKKK...",
  ],
  pixel_gem: [
    "..KKKKKKKK..", ".KBWBBBBLBK.", "KBWBBBBBBLLK", "KKKKKKKKKKKK", ".KBBKBBKBLK.",
    "..KBBBBBLK..", "..KCBBBCLK..", "...KBBBLK...", "....KBLK....", ".....KK.....",
  ],
  pixel_controller: [
    "..KKKKKKKKKK..", ".KLLLLLLLLLLK.", "KLLKLLLLLLPLLK", "KLKKKLLLLPLPLK", "KLLKLLKLKLPLLK",
    "KLLLLCLLCLLLLK", "KLLLLKKKKLLLLK", ".KLLK....KLLK.", "..KK......KK..",
  ],
  pixel_ghost: [
    "...KKKKKK...", "..KWWWWWWK..", ".KWWWWWWWWK.", "KWWWWWWWWWWK", "KWWKWWWWKWWK", "KWWKWWWWKWWK",
    "KWCWWKKWWCWK", "KWWWWWWWWWWK", "KWWWWWWWWWWK", "KWWWWWWWWWWK", "KWKWWKKWWKWK", "KK.KK..KK.KK",
  ],
  pixel_potion: [
    "....KKKK....", "....KNNK....", "....KKKK....", "....KWWK....", "...KWWWWK...", "..KWWWWWWK..", ".KPPPPPPPPK.",
    "KPWPPPPPPPPK", "KPWPKPPKPPPK", "KPPCPPPPCPPK", "KPPPPKKPPPPK", ".KPPPPPPPPK.", "..KKKKKKKK..",
  ],
  pixel_sword: [
    ".........KKK", "........KSWK", ".......KSWK.", "......KSWK..", ".....KSWK...", ".KK.KSWK....",
    ".KYKSWK.....", "..KYWK......", "..KNYK......", ".KNKKYK.....", "KNK...KK....", "KK..........",
  ],
  pixel_shield: [
    "KKKKKKKKKKKK", "KSSSSPPSSSSK", "KSWSSPPSSSSK", "KSWSSPPSSSSK", "KPPPPPPPPPPK", "KSSKSPPSKSSK", "KSSSSPPSSSSK",
    "KSCSSPPSSCSK", ".KSSSPPSSSK.", ".KSSSPPSSSK.", "..KSSPPSSK..", "...KSPPSK...", "....KKKK....",
  ],
  pixel_key: [
    "..KKKK........", ".KYYYYK.......", "KYWKKYYKKKKKKK", "KYK..KYYYYYYYK",
    "KYK..KYYKKYKYK", "KYYKKYYK.KK.KK", ".KYYYYK.......", "..KKKK........",
  ],
};

export const PIXEL_KINDS = Object.keys(GRIDS);

export const PixelArt = ({ kind, className }) => {
  const rows = GRIDS[kind];
  const w = Math.max(...rows.map((r) => r.length));
  const s = Math.max(w, rows.length) + 1;
  const ox = (s - w) / 2;
  const oy = (s - rows.length) / 2;
  return (
    <svg viewBox={`0 0 ${s} ${s}`} className={className} shapeRendering="crispEdges" aria-hidden="true">
      {rows.flatMap((row, y) =>
        [...row].map((ch, x) =>
          COLORS[ch] ? <rect key={`${x}-${y}`} x={x + ox} y={y + oy} width="1.02" height="1.02" fill={COLORS[ch]} /> : null
        )
      )}
    </svg>
  );
};
